import { Component, Input } from '@angular/core';
import { AuthLinkType } from '../../../../enums/event/event-data.enum';

@Component({
    selector: 'app-be-button',
    templateUrl: './be-button.component.html',
    standalone: false
})
export class ButtonComponent {
  @Input() eevTrackClick: AuthLinkType;
  @Input() isDisabled = false;
  @Input({ required: true }) type: 'submit' | 'button';
  @Input() buttonTitle?: string;
  @Input() spinnerTheme: 'light' | 'dark' = 'light';
  @Input() spinnerSize: 'xl' | 'lg' | 'md' | 'sm' | 'xs' = 'sm';

  @Input()
  set isLoading(value: boolean) {
    this.loading = value;
    this.loadingClass = value ? 'loading' : '';
  }
  @Input()
  set size(value: 'xsmall-responsive' | 'small' | 'large') {
    if (value) this.sizeClass = `be-btn--${value}`;
  }

  @Input()
  set variant(
    value:
      | 'ghost'
      | 'borderless'
      | 'link'
      | 'alt'
      | 'alt-ghost'
      | 'alt-borderless'
      | 'alt-link'
      | 'dark'
      | 'dark-ghost'
      | 'dark-borderless'
      | 'dark-link'
      | 'alt-dark'
      | 'alt-dark-ghost'
      | 'alt-dark-borderless'
      | 'alt-dark-link'
      | 'active'
      | 'back'
  ) {
    if (value) this.variantClass = `be-btn--${value}`;
  }

  public sizeClass: string = '';
  public variantClass: string = '';
  public loading: boolean = false;
  public loadingClass: string = '';
}
